import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-programador-logistica',
  templateUrl: './menu-programador-logistica.component.html',
  styleUrls: ['./menu-programador-logistica.component.scss']
})
export class MenuProgramadorLogisticaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
